import { Archive, BoxIso, Calendar, Star, ViewGrid } from "iconoir-react";
import { type IAppViewSection } from "shared/components";

export enum WidgetKey {
  All = "ALL",
  Archived = "ARCHIVED",
  Event = "EVENT",
  Favorited = "FAVORITED",
  Operator = "OPERATOR",
}

export const widgetViewSections: IAppViewSection[] = [
  {
    items: [
      {
        Icon: BoxIso,
        key: WidgetKey.All,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: ViewGrid,
        key: WidgetKey.Operator,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: Calendar,
        key: WidgetKey.Event,
        text: "",
        count: 0,
        isSelected: false,
      },
      {
        Icon: Star,
        key: WidgetKey.Favorited,
        text: "",
        count: 0,
        isSelected: false,
      },
    ],
  },
  {
    items: [
      {
        Icon: Archive,
        key: WidgetKey.Archived,
        text: "",
        count: 0,
        isSelected: false,
      },
    ],
  },
];
